import { Controller } from "stimulus";

export default class extends Controller {
  update(event) {
    const locale = event.target.value;
    fetch(`/languages?locale=${locale}`, { method: "PATCH" });
    window.location.reload();
  }
}